import { SectionLoader, Spacer } from '@airship-platform/jam-web/components';
import Box from '@mui/material/Box';
import { PropsWithChildren } from 'react';
import { useOrganizationSOWs } from '../../../data-access/organizationSOWs';
import SOWQueryForm from './SOWQueryForm';

const SOWQuery: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoaded, isLoading } = useOrganizationSOWs();

  if (isLoading && !isLoaded) {
    return <SectionLoader isLoading title={'Fetching statements of work...'} />;
  }

  return (
    <Box
      component={'form'}
      autoComplete="off"
      sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%' }}
    >
      <SOWQueryForm />
      {children}
      <Spacer height="2rem" />
    </Box>
  );
};

export default SOWQuery;
